var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F6B119",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.94 2.046A6.94 6.94 0 0 0 7 0a6.94 6.94 0 0 0-4.94 2.046 6.94 6.94 0 0 0-2.045 4.94c0 3.774 3.569 6.914 5.486 8.6.266.235.496.437.68.608.23.215.524.322.819.322.295 0 .59-.107.82-.322.183-.171.413-.373.68-.608 1.917-1.686 5.485-4.826 5.485-8.6a6.94 6.94 0 0 0-2.046-4.94zM7.86 14.86c-.272.24-.507.446-.701.627a.233.233 0 0 1-.318 0c-.194-.18-.429-.388-.701-.627C4.337 13.274.982 10.323.982 6.985.982 3.667 3.682.968 7 .968c3.318 0 6.018 2.7 6.018 6.017 0 3.338-3.355 6.29-5.158 7.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3.643a3.082 3.082 0 0 0-3.078 3.079A3.082 3.082 0 0 0 7 9.8a3.082 3.082 0 0 0 3.078-3.078A3.082 3.082 0 0 0 7 3.643zm0 5.19a2.113 2.113 0 0 1-2.11-2.111c0-1.164.946-2.111 2.11-2.111s2.11.947 2.11 2.11c0 1.164-.946 2.111-2.11 2.111z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOrange);
export default __webpack_public_path__ + "static/media/location-orange.db1df356c1397bb330d87143d5cdfd72.svg";
export { ForwardRef as ReactComponent };